<template>
  <v-container>
    <v-card class="ma-auto card" flat>
      <v-card-title>
        <v-banner class="mr-auto ml-auto" align="center">
          <v-avatar size="250">
            <v-img contain src="@/assets/undraw/undraw_authentication_fsn5.svg"></v-img>
          </v-avatar>
        </v-banner>
      </v-card-title>
      <v-card-text>
        <p class="text" style="word-break: break-word">
          Fehlende Berechtigung zu dieser Seite! <br />
          Bitte mit geeigneten Zugriffsrechten anmelden.
        </p>
        <p v-if="requiredPermission.action">
          Benötigte Berechtigung: {{ requiredPermission.action }}.{{ requiredPermission.subject }}
        </p>
        <v-btn @click="backToLogin" class="button mt-2" block x-large outlined data-test-login-again color="primary">
          Erneut Anmelden
        </v-btn>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/me-user.store";

@Component({
  components: {}
})
export default class LoginCardUnauthorized extends Vue {
  constructor() {
    super();
  }

  get requiredPermission() {
    return this.$route.params;
  }

  async mounted() {
    if (this.$route.params.action && this.$route.params.subject) {
      try {
        this.$log.info("Update User.");
        await UserModule.getUserInfo();
      } catch (error) {
        this.$log.error(error);
      }
      if (UserModule.abilities.can(this.$route.params.action, this.$route.params.subject)) {
        this.$log.info("User has permission.");
        this.$router.go(-1);
      }
    }
  }

  async backToLogin() {
    await UserModule.logout();
    this.$router.push({ path: "/login" });
  }
}
</script>

<style scoped>
.button {
  height: 40px !important;
  display: block;
  margin: auto;
  font-size: 110% !important;
  font-weight: 900;
}

.text {
  font-weight: 700;
}

.card {
  max-width: 650px;
}
</style>
